module.exports = __webpack_public_path__ + "img/ids-logs-tab.fa2cfad1.png";